import PropTypes from "prop-types";
import {useEffect, useRef, useState} from "react";
import CustomInput from "../CustomInput";
import CustomTextArea from "../CustomTextArea";
import Loading from "../Loading";
import emailjs from '@emailjs/browser';
import WarnLabelArea from "../WarnLabelArea";
import SuccessLabelArea from "../SuccessLabelArea";
import CustomCaptcha from "../CustomCaptcha";
// 캡챠

const  SendEmailForm2 = ({setIsOpenEmailModal}) => {
    const [emailName, setEmailName] = useState('');
    const [emailAddr, setEmailAddr] = useState('');
    const [emailTel, setEmailTel] = useState('');
    const [emailContent, setEmailContent] = useState();

    const [captchaResult, setCaptchaResult] = useState(false);

    const failMsg = '⚠️ 이메일 발송에 실패하였습니다.';
    const successMsg = '📨 이메일 발송에 성공하였습니다.'
    const captchaFailMsg = '⚠️ 자동입력 방지 문자가 일치하지 않습니다.'

    const emailFormRef = useRef();
    const customCaptchaRef = useRef();

    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isShowCaptchaError, setIsShowCaptchaError] = useState(false);

    useEffect(() => {
        setIsLoading(false);

        // ui 조정
        document.querySelector('.gnb-container')?.classList.add('min-vh-100');
        return () => {
            document.querySelector('.gnb-container')?.classList.remove('min-vh-100');
        }
    }, [])

    const content = {
        notice: `* "회신받을 이메일" 또는  * "회신받을 연락처" 로 회신이 발신됩니다.`,
        title: '이메일 문의',
        content: '안내 내용 - TEST',
        sender: '보내는 분(성함 및 기업명)',
        receiveEmailAddr: '회신받을 이메일',
        receiveMobile: '회신받을 연락처',
        mailContent: '내용',
        sendBtn: '전송',
        closeBtn: '취소',
    }


    const sendEmail = async () => {
        if (!customCaptchaRef?.current?.isValidCaptcha()) {
            setIsShowCaptchaError(true);
            return;
        }

        setIsLoading(true);
        setIsError(false);
        setIsSuccess(false);
        try {
            await emailjs.sendForm(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                emailFormRef.current,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
            );
            setIsError(false);
            setIsSuccess(true);
            customCaptchaRef?.current?.reloadCaptcha();
        } catch (e) {
            console.error('sendEmail Error : ', e);
            setIsError(true);
            setIsSuccess(false);
        } finally {
            setIsLoading(false);
            setCaptchaResult(false);
            setIsShowCaptchaError(false);
        }
    }

    const closeModal = () => {
        setIsOpenEmailModal(false);
    }

    return (<>
        <header
            // className='border-bottom lh-1 py-3'
            className='lh-1 py-3'
        >
            <div className="modal modal-sheet position-static d-block"
                 tabIndex="-1"
                 role="dialog"
                 id="modalSheet">
                <div className="modal-dialog">
                    <form
                        className="modal-content rounded-4 shadow"
                        ref={emailFormRef}>
                        <div className="modal-header border-bottom-0"><h1
                            className="modal-title fs-5">{content?.title}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                    onClick={closeModal}></button>
                        </div>
                        {isError && (
                            <WarnLabelArea>
                                <p>{failMsg}</p>
                            </WarnLabelArea>

                        )}
                        {isSuccess && (
                            <SuccessLabelArea>
                                <p>{successMsg}</p>
                            </SuccessLabelArea>
                        )}
                        {/* 발신자 정보*/}
                        <div className="modal-body p-5 pt-0">
                            <input type="text" hidden={true} name={"site_url"} value={'joonbok lee 웹 포트폴리오'} readOnly/>
                            <input type="text" hidden={true} name={"time"} value={new Date()} readOnly/>
                            <div className="form-floating mb-3">
                                <CustomInput
                                    label={content?.sender}
                                    id={"floatingInput"}
                                    name={"name"}
                                    className={"form-control rounded-3"}
                                    type={"text"}
                                    placeholder={"홍길동 또는 oo컴퍼니"}
                                    inputHandler={setEmailName}
                                    maxLength={30}/>
                            </div>
                            <div className="form-floating mb-3">
                                <CustomInput
                                    label={content?.receiveEmailAddr}
                                    id={"floatingInput"}
                                    name={"email"}
                                    className={"form-control rounded-3"}
                                    type={"email"}
                                    placeholder={"name@example.com"}
                                    inputHandler={setEmailAddr}
                                    maxLength={50}/>
                            </div>
                            <div className="form-floating mb-3">
                                <CustomInput
                                    label={content?.receiveMobile}
                                    id={"floatingInput"}
                                    name={"tel"}
                                    className={"form-control rounded-3"}
                                    type={"tel"}
                                    placeholder={"000-0000-0000"}
                                    inputHandler={setEmailTel}
                                    pattern={"[0-9]+"}
                                    maxLength={20}/>
                            </div>
                            <div className="form-floating">
                                <CustomTextArea
                                    label={content?.mailContent}
                                    id={"floatingTextarea2"}
                                    name={"message"}
                                    className={"form-control"}
                                    placeholder={'내용을 입력해주세요.'}
                                    inputHandler={setEmailContent}
                                    areaHeight={"350px"}
                                    maxLength={300}/>
                            </div>
                            <div className='form-floating'>
                                <CustomCaptcha ref={customCaptchaRef} key="captcha"/>
                                {isShowCaptchaError && (
                                    <div className="alert alert-danger" role="alert">
                                        {captchaFailMsg}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer align-items-stretch w-100 gap-2 pb-3 border-top-0">
                            <button type="button" className="btn btn-lg btn-primary" onClick={async () => {
                                sendEmail();
                            }}>{content.sendBtn}</button>
                            <button type="button" className="btn btn-lg btn-secondary" data-bs-dismiss="modal"
                                    onClick={closeModal}>
                                {content.closeBtn}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </header>
        {isLoading && (
            <Loading/>
        )}
    </>);
}


SendEmailForm2.propTypes = {
    setIsOpenEmailModal: PropTypes.func.isRequired,
};

SendEmailForm2.defaultProps = {
    setIsOpenEmailModal: () => {
    },
};

export default SendEmailForm2;
